import { LogLevelEnum } from '@algolia/logger-common';
import { createConsoleLogger } from '@algolia/logger-console';
import algoliasearch from 'algoliasearch/lite';

interface IClientOpts {
  logger: any;
  hosts?: any;
}

export function NewSearchClient() {
  const opts: IClientOpts = {
    logger: createConsoleLogger(LogLevelEnum.INFO),
  };

  const host = process.env.NEXT_PUBLIC_SEARCH_PROXY;
  if (host) {
    opts['hosts'] = [
      {
        url: host,
        accept: 1,
        protocol: host.match(/localhost/) ? 'http' : 'https',
      },
    ];
  }

  return algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID as string,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY as string,
    opts,
  );
}

export const INDEX_NAMES = {
  resources: 'firestore.resources',
  resourcesDesc: 'firestore.resources.created_at_desc',
  topics: 'firestore.topics',
  categories: 'firestore.categories',
};

export const client = NewSearchClient();
export const indexes = {
  resources: client.initIndex(INDEX_NAMES.resources),
  resourcesDesc: client.initIndex(INDEX_NAMES.resourcesDesc),
  topics: client.initIndex(INDEX_NAMES.topics),
  categories: client.initIndex(INDEX_NAMES.categories),
};
